export default {
  interests: 'Intereses',
};
